/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.9.0 (NJsonSchema v10.4.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
} from 'rxjs/operators';
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IClient {
  /**
   * @return Success
   */
  metaData(): Observable<MetaDataPubMed[]>;
  /**
   * @param body (optional)
   * @return Success
   */
  search(body: SearchQuery | undefined): Observable<SearchPage>;
  /**
   * @param pmid (optional)
   * @return Success
   */
  getDetailedArticle(
    pmid: string | null | undefined
  ): Observable<DetailedArticle>;
  /**
   * @param pmid (optional)
   * @param type (optional)
   * @param score (optional)
   * @param body (optional)
   * @return Success
   */
  insertProcessedSync4Data(
    pmid: string | null | undefined,
    type: string | null | undefined,
    score: number | undefined,
    body: string | null | undefined
  ): Observable<boolean>;
  /**
   * @param code (optional)
   * @return Success
   */
  mock(code: string | null | undefined): Observable<boolean>;
  /**
   * @param fromDate (optional)
   * @return Success
   */
  runWebcrawlerFromDate(fromDate: Date | undefined): Observable<boolean>;
  /**
   * @return Success
   */
  runWebcrawler(): Observable<boolean>;
  /**
   * @return Success
   */
  resetWebcrawler(): Observable<boolean>;
  /**
   * @return Success
   */
  runMock(): Observable<boolean>;
}

@Injectable()
export class Client implements IClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    @Inject(HttpClient) http: HttpClient,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : '';
    this.baseUrl = 'https://localhost:44341';
    this.baseUrl = 'https://api-metadata.covid-learning.com';
  }

  /**
   * @return Success
   */
  metaData(): Observable<MetaDataPubMed[]> {
    let url_ = this.baseUrl + '/MetaData';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMetaData(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMetaData(<any>response_);
            } catch (e) {
              return <Observable<MetaDataPubMed[]>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<MetaDataPubMed[]>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processMetaData(
    response: HttpResponseBase
  ): Observable<MetaDataPubMed[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(MetaDataPubMed.fromJS(item));
          }
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<MetaDataPubMed[]>(<any>null);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  search(body: SearchQuery | undefined): Observable<SearchPage> {
    let url_ = this.baseUrl + '/Search';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch(<any>response_);
            } catch (e) {
              return <Observable<SearchPage>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<SearchPage>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processSearch(response: HttpResponseBase): Observable<SearchPage> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SearchPage.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SearchPage>(<any>null);
  }

  /**
   * @param pmid (optional)
   * @return Success
   */
  getDetailedArticle(
    pmid: string | null | undefined
  ): Observable<DetailedArticle> {
    let url_ = this.baseUrl + '/Search/GetDetailedArticle?';
    if (pmid !== undefined && pmid !== null)
      url_ += 'pmid=' + encodeURIComponent('' + pmid) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDetailedArticle(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetDetailedArticle(<any>response_);
            } catch (e) {
              return <Observable<DetailedArticle>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<DetailedArticle>>(
              (<any>_observableThrow(response_))
            );
        })
      );
  }

  protected processGetDetailedArticle(
    response: HttpResponseBase
  ): Observable<DetailedArticle> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DetailedArticle.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DetailedArticle>(<any>null);
  }

  /**
   * @param pmid (optional)
   * @param type (optional)
   * @param score (optional)
   * @param body (optional)
   * @return Success
   */
  insertProcessedSync4Data(
    pmid: string | null | undefined,
    type: string | null | undefined,
    score: number | undefined,
    body: string | null | undefined
  ): Observable<boolean> {
    let url_ = this.baseUrl + '/Sync4Data/InsertProcessedSync4Data?';
    if (pmid !== undefined && pmid !== null)
      url_ += 'pmid=' + encodeURIComponent('' + pmid) + '&';
    if (type !== undefined && type !== null)
      url_ += 'type=' + encodeURIComponent('' + type) + '&';
    if (score === null)
      throw new Error("The parameter 'score' cannot be null.");
    else if (score !== undefined)
      url_ += 'score=' + encodeURIComponent('' + score) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processInsertProcessedSync4Data(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processInsertProcessedSync4Data(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processInsertProcessedSync4Data(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @param code (optional)
   * @return Success
   */
  mock(code: string | null | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/Sync4Data/Mock?';
    if (code !== undefined && code !== null)
      url_ += 'code=' + encodeURIComponent('' + code) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMock(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMock(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processMock(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @param fromDate (optional)
   * @return Success
   */
  runWebcrawlerFromDate(fromDate: Date | undefined): Observable<boolean> {
    let url_ = this.baseUrl + '/Webcrawler/RunWebcrawlerFromDate?';
    if (fromDate === null)
      throw new Error("The parameter 'fromDate' cannot be null.");
    else if (fromDate !== undefined)
      url_ +=
        'fromDate=' +
        encodeURIComponent(fromDate ? '' + fromDate.toJSON() : '') +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRunWebcrawlerFromDate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRunWebcrawlerFromDate(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRunWebcrawlerFromDate(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @return Success
   */
  runWebcrawler(): Observable<boolean> {
    let url_ = this.baseUrl + '/Webcrawler/RunWebcrawler';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRunWebcrawler(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRunWebcrawler(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRunWebcrawler(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @return Success
   */
  resetWebcrawler(): Observable<boolean> {
    let url_ = this.baseUrl + '/Webcrawler/ResetWebcrawler';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetWebcrawler(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetWebcrawler(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processResetWebcrawler(
    response: HttpResponseBase
  ): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }

  /**
   * @return Success
   */
  runMock(): Observable<boolean> {
    let url_ = this.baseUrl + '/Webcrawler/RunMock';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRunMock(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRunMock(<any>response_);
            } catch (e) {
              return <Observable<boolean>>(<any>_observableThrow(e));
            }
          } else return <Observable<boolean>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processRunMock(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(<any>null);
  }
}

export class MetaDataPubMed implements IMetaDataPubMed {
  id?: number;
  pmid?: string | undefined;
  date?: Date;
  metaData?: string | undefined;

  constructor(data?: IMetaDataPubMed) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.pmid = _data['pmid'];
      this.date = _data['date']
        ? new Date(_data['date'].toString())
        : <any>undefined;
      this.metaData = _data['metaData'];
    }
  }

  static fromJS(data: any): MetaDataPubMed {
    data = typeof data === 'object' ? data : {};
    let result = new MetaDataPubMed();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['pmid'] = this.pmid;
    data['date'] = this.date ? this.date.toISOString() : <any>undefined;
    data['metaData'] = this.metaData;
    return data;
  }
}

export interface IMetaDataPubMed {
  id?: number;
  pmid?: string | undefined;
  date?: Date;
  metaData?: string | undefined;
}

export class SearchQuery implements ISearchQuery {
  term?: string | undefined;
  pageIndex?: number;
  pageSize?: number;

  constructor(data?: ISearchQuery) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.term = _data['term'];
      this.pageIndex = _data['pageIndex'];
      this.pageSize = _data['pageSize'];
    }
  }

  static fromJS(data: any): SearchQuery {
    data = typeof data === 'object' ? data : {};
    let result = new SearchQuery();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['term'] = this.term;
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    return data;
  }
}

export interface ISearchQuery {
  term?: string | undefined;
  pageIndex?: number;
  pageSize?: number;
}

export class PubtatorTerm implements IPubtatorTerm {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;

  constructor(data?: IPubtatorTerm) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data['uniqueId'];
      if (Array.isArray(_data['treeNumbers'])) {
        this.treeNumbers = [] as any;
        for (let item of _data['treeNumbers']) this.treeNumbers!.push(item);
      }
      this.meshHeading = _data['meshHeading'];
    }
  }

  static fromJS(data: any): PubtatorTerm {
    data = typeof data === 'object' ? data : {};
    let result = new PubtatorTerm();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['uniqueId'] = this.uniqueId;
    if (Array.isArray(this.treeNumbers)) {
      data['treeNumbers'] = [];
      for (let item of this.treeNumbers) data['treeNumbers'].push(item);
    }
    data['meshHeading'] = this.meshHeading;
    return data;
  }
}

export interface IPubtatorTerm {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;
}

export class JointDeduplicatedMesh implements IJointDeduplicatedMesh {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;

  constructor(data?: IJointDeduplicatedMesh) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data['uniqueId'];
      if (Array.isArray(_data['treeNumbers'])) {
        this.treeNumbers = [] as any;
        for (let item of _data['treeNumbers']) this.treeNumbers!.push(item);
      }
      this.meshHeading = _data['meshHeading'];
    }
  }

  static fromJS(data: any): JointDeduplicatedMesh {
    data = typeof data === 'object' ? data : {};
    let result = new JointDeduplicatedMesh();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['uniqueId'] = this.uniqueId;
    if (Array.isArray(this.treeNumbers)) {
      data['treeNumbers'] = [];
      for (let item of this.treeNumbers) data['treeNumbers'].push(item);
    }
    data['meshHeading'] = this.meshHeading;
    return data;
  }
}

export interface IJointDeduplicatedMesh {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;
}

export class First implements IFirst {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;

  constructor(data?: IFirst) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data['uniqueId'];
      if (Array.isArray(_data['treeNumbers'])) {
        this.treeNumbers = [] as any;
        for (let item of _data['treeNumbers']) this.treeNumbers!.push(item);
      }
      this.meshHeading = _data['meshHeading'];
    }
  }

  static fromJS(data: any): First {
    data = typeof data === 'object' ? data : {};
    let result = new First();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['uniqueId'] = this.uniqueId;
    if (Array.isArray(this.treeNumbers)) {
      data['treeNumbers'] = [];
      for (let item of this.treeNumbers) data['treeNumbers'].push(item);
    }
    data['meshHeading'] = this.meshHeading;
    return data;
  }
}

export interface IFirst {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;
}

export class Third implements IThird {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;

  constructor(data?: IThird) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data['uniqueId'];
      if (Array.isArray(_data['treeNumbers'])) {
        this.treeNumbers = [] as any;
        for (let item of _data['treeNumbers']) this.treeNumbers!.push(item);
      }
      this.meshHeading = _data['meshHeading'];
    }
  }

  static fromJS(data: any): Third {
    data = typeof data === 'object' ? data : {};
    let result = new Third();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['uniqueId'] = this.uniqueId;
    if (Array.isArray(this.treeNumbers)) {
      data['treeNumbers'] = [];
      for (let item of this.treeNumbers) data['treeNumbers'].push(item);
    }
    data['meshHeading'] = this.meshHeading;
    return data;
  }
}

export interface IThird {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;
}

export class Second implements ISecond {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;

  constructor(data?: ISecond) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueId = _data['uniqueId'];
      if (Array.isArray(_data['treeNumbers'])) {
        this.treeNumbers = [] as any;
        for (let item of _data['treeNumbers']) this.treeNumbers!.push(item);
      }
      this.meshHeading = _data['meshHeading'];
    }
  }

  static fromJS(data: any): Second {
    data = typeof data === 'object' ? data : {};
    let result = new Second();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['uniqueId'] = this.uniqueId;
    if (Array.isArray(this.treeNumbers)) {
      data['treeNumbers'] = [];
      for (let item of this.treeNumbers) data['treeNumbers'].push(item);
    }
    data['meshHeading'] = this.meshHeading;
    return data;
  }
}

export interface ISecond {
  uniqueId?: string | undefined;
  treeNumbers?: string[] | undefined;
  meshHeading?: string | undefined;
}

export class MeshTermsByLevel implements IMeshTermsByLevel {
  first?: First[] | undefined;
  third?: Third[] | undefined;
  second?: Second[] | undefined;

  constructor(data?: IMeshTermsByLevel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['first'])) {
        this.first = [] as any;
        for (let item of _data['first']) this.first!.push(First.fromJS(item));
      }
      if (Array.isArray(_data['third'])) {
        this.third = [] as any;
        for (let item of _data['third']) this.third!.push(Third.fromJS(item));
      }
      if (Array.isArray(_data['second'])) {
        this.second = [] as any;
        for (let item of _data['second'])
          this.second!.push(Second.fromJS(item));
      }
    }
  }

  static fromJS(data: any): MeshTermsByLevel {
    data = typeof data === 'object' ? data : {};
    let result = new MeshTermsByLevel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.first)) {
      data['first'] = [];
      for (let item of this.first) data['first'].push(item.toJSON());
    }
    if (Array.isArray(this.third)) {
      data['third'] = [];
      for (let item of this.third) data['third'].push(item.toJSON());
    }
    if (Array.isArray(this.second)) {
      data['second'] = [];
      for (let item of this.second) data['second'].push(item.toJSON());
    }
    return data;
  }
}

export interface IMeshTermsByLevel {
  first?: First[] | undefined;
  third?: Third[] | undefined;
  second?: Second[] | undefined;
}

export class Classification implements IClassification {
  category?: string | undefined;
  weight?: number;

  constructor(data?: IClassification) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.category = _data['category'];
      this.weight = _data['weight'];
    }
  }

  static fromJS(data: any): Classification {
    data = typeof data === 'object' ? data : {};
    let result = new Classification();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['category'] = this.category;
    data['weight'] = this.weight;
    return data;
  }
}

export interface IClassification {
  category?: string | undefined;
  weight?: number;
}

export class Annotation implements IAnnotation {
  content?: string | undefined;
  position?: number;
  prefix?: string | undefined;
  suffix?: string | undefined;
  uuid?: string | undefined;

  constructor(data?: IAnnotation) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.content = _data['content'];
      this.position = _data['position'];
      this.prefix = _data['prefix'];
      this.suffix = _data['suffix'];
      this.uuid = _data['uuid'];
    }
  }

  static fromJS(data: any): Annotation {
    data = typeof data === 'object' ? data : {};
    let result = new Annotation();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['content'] = this.content;
    data['position'] = this.position;
    data['prefix'] = this.prefix;
    data['suffix'] = this.suffix;
    data['uuid'] = this.uuid;
    return data;
  }
}

export interface IAnnotation {
  content?: string | undefined;
  position?: number;
  prefix?: string | undefined;
  suffix?: string | undefined;
  uuid?: string | undefined;
}

export class RobotReviewer implements IRobotReviewer {
  annotations?: Annotation[] | undefined;
  domain?: string | undefined;
  judgement?: string | undefined;

  constructor(data?: IRobotReviewer) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['annotations'])) {
        this.annotations = [] as any;
        for (let item of _data['annotations'])
          this.annotations!.push(Annotation.fromJS(item));
      }
      this.domain = _data['domain'];
      this.judgement = _data['judgement'];
    }
  }

  static fromJS(data: any): RobotReviewer {
    data = typeof data === 'object' ? data : {};
    let result = new RobotReviewer();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.annotations)) {
      data['annotations'] = [];
      for (let item of this.annotations)
        data['annotations'].push(item.toJSON());
    }
    data['domain'] = this.domain;
    data['judgement'] = this.judgement;
    return data;
  }
}

export interface IRobotReviewer {
  annotations?: Annotation[] | undefined;
  domain?: string | undefined;
  judgement?: string | undefined;
}

export class EstimatedModelPerformance implements IEstimatedModelPerformance {
  mccConfidenceIntervalLowerBound?: number;
  mccConfidenceIntervalUpperBound?: number;
  mccConfidenceLevel?: number;
  mccMedian?: number;

  constructor(data?: IEstimatedModelPerformance) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.mccConfidenceIntervalLowerBound =
        _data['mccConfidenceIntervalLowerBound'];
      this.mccConfidenceIntervalUpperBound =
        _data['mccConfidenceIntervalUpperBound'];
      this.mccConfidenceLevel = _data['mccConfidenceLevel'];
      this.mccMedian = _data['mccMedian'];
    }
  }

  static fromJS(data: any): EstimatedModelPerformance {
    data = typeof data === 'object' ? data : {};
    let result = new EstimatedModelPerformance();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['mccConfidenceIntervalLowerBound'] =
      this.mccConfidenceIntervalLowerBound;
    data['mccConfidenceIntervalUpperBound'] =
      this.mccConfidenceIntervalUpperBound;
    data['mccConfidenceLevel'] = this.mccConfidenceLevel;
    data['mccMedian'] = this.mccMedian;
    return data;
  }
}

export interface IEstimatedModelPerformance {
  mccConfidenceIntervalLowerBound?: number;
  mccConfidenceIntervalUpperBound?: number;
  mccConfidenceLevel?: number;
  mccMedian?: number;
}

export class Probabilities implements IProbabilities {
  no?: number;
  yes?: number;

  constructor(data?: IProbabilities) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.no = _data['no'];
      this.yes = _data['yes'];
    }
  }

  static fromJS(data: any): Probabilities {
    data = typeof data === 'object' ? data : {};
    let result = new Probabilities();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['no'] = this.no;
    data['yes'] = this.yes;
    return data;
  }
}

export interface IProbabilities {
  no?: number;
  yes?: number;
}

export class Question0 implements IQuestion0 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion0) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question0 {
    data = typeof data === 'object' ? data : {};
    let result = new Question0();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion0 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question1 implements IQuestion1 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion1) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question1 {
    data = typeof data === 'object' ? data : {};
    let result = new Question1();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion1 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question10 implements IQuestion10 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion10) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question10 {
    data = typeof data === 'object' ? data : {};
    let result = new Question10();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion10 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question11 implements IQuestion11 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion11) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question11 {
    data = typeof data === 'object' ? data : {};
    let result = new Question11();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion11 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question12 implements IQuestion12 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion12) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question12 {
    data = typeof data === 'object' ? data : {};
    let result = new Question12();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion12 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question13 implements IQuestion13 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion13) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question13 {
    data = typeof data === 'object' ? data : {};
    let result = new Question13();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion13 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question14 implements IQuestion14 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion14) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question14 {
    data = typeof data === 'object' ? data : {};
    let result = new Question14();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion14 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question15 implements IQuestion15 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion15) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question15 {
    data = typeof data === 'object' ? data : {};
    let result = new Question15();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion15 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question16 implements IQuestion16 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion16) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question16 {
    data = typeof data === 'object' ? data : {};
    let result = new Question16();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion16 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question170 implements IQuestion170 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion170) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question170 {
    data = typeof data === 'object' ? data : {};
    let result = new Question170();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion170 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question171 implements IQuestion171 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion171) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question171 {
    data = typeof data === 'object' ? data : {};
    let result = new Question171();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion171 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question172 implements IQuestion172 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion172) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question172 {
    data = typeof data === 'object' ? data : {};
    let result = new Question172();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion172 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question173 implements IQuestion173 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion173) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question173 {
    data = typeof data === 'object' ? data : {};
    let result = new Question173();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion173 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question174 implements IQuestion174 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion174) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question174 {
    data = typeof data === 'object' ? data : {};
    let result = new Question174();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion174 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question175 implements IQuestion175 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion175) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question175 {
    data = typeof data === 'object' ? data : {};
    let result = new Question175();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion175 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question2 implements IQuestion2 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question2 {
    data = typeof data === 'object' ? data : {};
    let result = new Question2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion2 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question3 implements IQuestion3 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion3) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question3 {
    data = typeof data === 'object' ? data : {};
    let result = new Question3();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion3 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question4A implements IQuestion4A {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion4A) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question4A {
    data = typeof data === 'object' ? data : {};
    let result = new Question4A();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion4A {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question4B implements IQuestion4B {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion4B) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question4B {
    data = typeof data === 'object' ? data : {};
    let result = new Question4B();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion4B {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question5 implements IQuestion5 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion5) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question5 {
    data = typeof data === 'object' ? data : {};
    let result = new Question5();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion5 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question6 implements IQuestion6 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion6) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question6 {
    data = typeof data === 'object' ? data : {};
    let result = new Question6();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion6 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question7 implements IQuestion7 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion7) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question7 {
    data = typeof data === 'object' ? data : {};
    let result = new Question7();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion7 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question8 implements IQuestion8 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion8) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question8 {
    data = typeof data === 'object' ? data : {};
    let result = new Question8();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion8 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Question9 implements IQuestion9 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;

  constructor(data?: IQuestion9) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
      this.estimatedModelPerformance = _data['estimatedModelPerformance']
        ? EstimatedModelPerformance.fromJS(_data['estimatedModelPerformance'])
        : <any>undefined;
      this.probabilities = _data['probabilities']
        ? Probabilities.fromJS(_data['probabilities'])
        : <any>undefined;
      this.statement = _data['statement'];
      this.threshold = _data['threshold'];
    }
  }

  static fromJS(data: any): Question9 {
    data = typeof data === 'object' ? data : {};
    let result = new Question9();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    data['estimatedModelPerformance'] = this.estimatedModelPerformance
      ? this.estimatedModelPerformance.toJSON()
      : <any>undefined;
    data['probabilities'] = this.probabilities
      ? this.probabilities.toJSON()
      : <any>undefined;
    data['statement'] = this.statement;
    data['threshold'] = this.threshold;
    return data;
  }
}

export interface IQuestion9 {
  answer?: string | undefined;
  estimatedModelPerformance?: EstimatedModelPerformance;
  probabilities?: Probabilities;
  statement?: string | undefined;
  threshold?: number;
}

export class Predictions implements IPredictions {
  question0?: Question0;
  question1?: Question1;
  question10?: Question10;
  question11?: Question11;
  question12?: Question12;
  question13?: Question13;
  question14?: Question14;
  question15?: Question15;
  question16?: Question16;
  question170?: Question170;
  question171?: Question171;
  question172?: Question172;
  question173?: Question173;
  question174?: Question174;
  question175?: Question175;
  question2?: Question2;
  question3?: Question3;
  question4A?: Question4A;
  question4B?: Question4B;
  question5?: Question5;
  question6?: Question6;
  question7?: Question7;
  question8?: Question8;
  question9?: Question9;

  constructor(data?: IPredictions) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.question0 = _data['question0']
        ? Question0.fromJS(_data['question0'])
        : <any>undefined;
      this.question1 = _data['question1']
        ? Question1.fromJS(_data['question1'])
        : <any>undefined;
      this.question10 = _data['question10']
        ? Question10.fromJS(_data['question10'])
        : <any>undefined;
      this.question11 = _data['question11']
        ? Question11.fromJS(_data['question11'])
        : <any>undefined;
      this.question12 = _data['question12']
        ? Question12.fromJS(_data['question12'])
        : <any>undefined;
      this.question13 = _data['question13']
        ? Question13.fromJS(_data['question13'])
        : <any>undefined;
      this.question14 = _data['question14']
        ? Question14.fromJS(_data['question14'])
        : <any>undefined;
      this.question15 = _data['question15']
        ? Question15.fromJS(_data['question15'])
        : <any>undefined;
      this.question16 = _data['question16']
        ? Question16.fromJS(_data['question16'])
        : <any>undefined;
      this.question170 = _data['question170']
        ? Question170.fromJS(_data['question170'])
        : <any>undefined;
      this.question171 = _data['question171']
        ? Question171.fromJS(_data['question171'])
        : <any>undefined;
      this.question172 = _data['question172']
        ? Question172.fromJS(_data['question172'])
        : <any>undefined;
      this.question173 = _data['question173']
        ? Question173.fromJS(_data['question173'])
        : <any>undefined;
      this.question174 = _data['question174']
        ? Question174.fromJS(_data['question174'])
        : <any>undefined;
      this.question175 = _data['question175']
        ? Question175.fromJS(_data['question175'])
        : <any>undefined;
      this.question2 = _data['question2']
        ? Question2.fromJS(_data['question2'])
        : <any>undefined;
      this.question3 = _data['question3']
        ? Question3.fromJS(_data['question3'])
        : <any>undefined;
      this.question4A = _data['question4A']
        ? Question4A.fromJS(_data['question4A'])
        : <any>undefined;
      this.question4B = _data['question4B']
        ? Question4B.fromJS(_data['question4B'])
        : <any>undefined;
      this.question5 = _data['question5']
        ? Question5.fromJS(_data['question5'])
        : <any>undefined;
      this.question6 = _data['question6']
        ? Question6.fromJS(_data['question6'])
        : <any>undefined;
      this.question7 = _data['question7']
        ? Question7.fromJS(_data['question7'])
        : <any>undefined;
      this.question8 = _data['question8']
        ? Question8.fromJS(_data['question8'])
        : <any>undefined;
      this.question9 = _data['question9']
        ? Question9.fromJS(_data['question9'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): Predictions {
    data = typeof data === 'object' ? data : {};
    let result = new Predictions();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['question0'] = this.question0
      ? this.question0.toJSON()
      : <any>undefined;
    data['question1'] = this.question1
      ? this.question1.toJSON()
      : <any>undefined;
    data['question10'] = this.question10
      ? this.question10.toJSON()
      : <any>undefined;
    data['question11'] = this.question11
      ? this.question11.toJSON()
      : <any>undefined;
    data['question12'] = this.question12
      ? this.question12.toJSON()
      : <any>undefined;
    data['question13'] = this.question13
      ? this.question13.toJSON()
      : <any>undefined;
    data['question14'] = this.question14
      ? this.question14.toJSON()
      : <any>undefined;
    data['question15'] = this.question15
      ? this.question15.toJSON()
      : <any>undefined;
    data['question16'] = this.question16
      ? this.question16.toJSON()
      : <any>undefined;
    data['question170'] = this.question170
      ? this.question170.toJSON()
      : <any>undefined;
    data['question171'] = this.question171
      ? this.question171.toJSON()
      : <any>undefined;
    data['question172'] = this.question172
      ? this.question172.toJSON()
      : <any>undefined;
    data['question173'] = this.question173
      ? this.question173.toJSON()
      : <any>undefined;
    data['question174'] = this.question174
      ? this.question174.toJSON()
      : <any>undefined;
    data['question175'] = this.question175
      ? this.question175.toJSON()
      : <any>undefined;
    data['question2'] = this.question2
      ? this.question2.toJSON()
      : <any>undefined;
    data['question3'] = this.question3
      ? this.question3.toJSON()
      : <any>undefined;
    data['question4A'] = this.question4A
      ? this.question4A.toJSON()
      : <any>undefined;
    data['question4B'] = this.question4B
      ? this.question4B.toJSON()
      : <any>undefined;
    data['question5'] = this.question5
      ? this.question5.toJSON()
      : <any>undefined;
    data['question6'] = this.question6
      ? this.question6.toJSON()
      : <any>undefined;
    data['question7'] = this.question7
      ? this.question7.toJSON()
      : <any>undefined;
    data['question8'] = this.question8
      ? this.question8.toJSON()
      : <any>undefined;
    data['question9'] = this.question9
      ? this.question9.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IPredictions {
  question0?: Question0;
  question1?: Question1;
  question10?: Question10;
  question11?: Question11;
  question12?: Question12;
  question13?: Question13;
  question14?: Question14;
  question15?: Question15;
  question16?: Question16;
  question170?: Question170;
  question171?: Question171;
  question172?: Question172;
  question173?: Question173;
  question174?: Question174;
  question175?: Question175;
  question2?: Question2;
  question3?: Question3;
  question4A?: Question4A;
  question4B?: Question4B;
  question5?: Question5;
  question6?: Question6;
  question7?: Question7;
  question8?: Question8;
  question9?: Question9;
}

export class P5 implements IP5 {
  predictions?: Predictions;

  constructor(data?: IP5) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.predictions = _data['predictions']
        ? Predictions.fromJS(_data['predictions'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): P5 {
    data = typeof data === 'object' ? data : {};
    let result = new P5();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['predictions'] = this.predictions
      ? this.predictions.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IP5 {
  predictions?: Predictions;
}

export class Score implements IScore {
  num?: number;
  over?: number;
  scoreValue?: number;

  constructor(data?: IScore) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.num = _data['num'];
      this.over = _data['over'];
      this.scoreValue = _data['scoreValue'];
    }
  }

  static fromJS(data: any): Score {
    data = typeof data === 'object' ? data : {};
    let result = new Score();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['num'] = this.num;
    data['over'] = this.over;
    data['scoreValue'] = this.scoreValue;
    return data;
  }
}

export interface IScore {
  num?: number;
  over?: number;
  scoreValue?: number;
}

export class Sync4DataResult implements ISync4DataResult {
  id?: number;
  pmid?: string | undefined;
  database?: string | undefined;
  title?: string | undefined;
  abstract?: string | undefined;
  authors?: string[] | undefined;
  preIndexedMesh?: string[] | undefined;
  journal?: string | undefined;
  publicationDate?: string | undefined;
  pmc?: string | undefined;
  grants?: any[] | undefined;
  otherIndexedKeywords?: string[] | undefined;
  doi?: string | undefined;
  conflictsOfInterest?: any | undefined;
  pubtatorTerms?: PubtatorTerm[] | undefined;
  jointDeduplicatedMesh?: JointDeduplicatedMesh[] | undefined;
  meshTermsByLevel?: MeshTermsByLevel;
  classification?: Classification[] | undefined;
  isRct?: boolean;
  isSr?: boolean;
  isMa?: boolean;
  robotReviewer?: RobotReviewer[] | undefined;
  p5?: P5;
  score?: Score;
  articleType?: string | undefined;
  showDetail?: boolean;
  feedback?: number;
  order?: number;

  constructor(data?: ISync4DataResult) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.pmid = _data['pmid'];
      this.database = _data['database'];
      this.title = _data['title'];
      this.abstract = _data['abstract'];
      if (Array.isArray(_data['authors'])) {
        this.authors = [] as any;
        for (let item of _data['authors']) this.authors!.push(item);
      }
      if (Array.isArray(_data['preIndexedMesh'])) {
        this.preIndexedMesh = [] as any;
        for (let item of _data['preIndexedMesh'])
          this.preIndexedMesh!.push(item);
      }
      this.journal = _data['journal'];
      this.publicationDate = _data['publicationDate'];
      this.pmc = _data['pmc'];
      if (Array.isArray(_data['grants'])) {
        this.grants = [] as any;
        for (let item of _data['grants']) this.grants!.push(item);
      }
      if (Array.isArray(_data['otherIndexedKeywords'])) {
        this.otherIndexedKeywords = [] as any;
        for (let item of _data['otherIndexedKeywords'])
          this.otherIndexedKeywords!.push(item);
      }
      this.doi = _data['doi'];
      this.conflictsOfInterest = _data['conflictsOfInterest'];
      if (Array.isArray(_data['pubtatorTerms'])) {
        this.pubtatorTerms = [] as any;
        for (let item of _data['pubtatorTerms'])
          this.pubtatorTerms!.push(PubtatorTerm.fromJS(item));
      }
      if (Array.isArray(_data['jointDeduplicatedMesh'])) {
        this.jointDeduplicatedMesh = [] as any;
        for (let item of _data['jointDeduplicatedMesh'])
          this.jointDeduplicatedMesh!.push(JointDeduplicatedMesh.fromJS(item));
      }
      this.meshTermsByLevel = _data['meshTermsByLevel']
        ? MeshTermsByLevel.fromJS(_data['meshTermsByLevel'])
        : <any>undefined;
      if (Array.isArray(_data['classification'])) {
        this.classification = [] as any;
        for (let item of _data['classification'])
          this.classification!.push(Classification.fromJS(item));
      }
      this.isRct = _data['isRct'];
      this.isSr = _data['isSr'];
      this.isMa = _data['isMa'];
      if (Array.isArray(_data['robotReviewer'])) {
        this.robotReviewer = [] as any;
        for (let item of _data['robotReviewer'])
          this.robotReviewer!.push(RobotReviewer.fromJS(item));
      }
      this.p5 = _data['p5'] ? P5.fromJS(_data['p5']) : <any>undefined;
      this.score = _data['score']
        ? Score.fromJS(_data['score'])
        : <any>undefined;
      this.articleType = _data['articleType'];
      this.showDetail = _data['showDetail'];
      this.feedback = _data['feedback'];
      this.order = _data['order'];
    }
  }

  static fromJS(data: any): Sync4DataResult {
    data = typeof data === 'object' ? data : {};
    let result = new Sync4DataResult();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['pmid'] = this.pmid;
    data['database'] = this.database;
    data['title'] = this.title;
    data['abstract'] = this.abstract;
    if (Array.isArray(this.authors)) {
      data['authors'] = [];
      for (let item of this.authors) data['authors'].push(item);
    }
    if (Array.isArray(this.preIndexedMesh)) {
      data['preIndexedMesh'] = [];
      for (let item of this.preIndexedMesh) data['preIndexedMesh'].push(item);
    }
    data['journal'] = this.journal;
    data['publicationDate'] = this.publicationDate;
    data['pmc'] = this.pmc;
    if (Array.isArray(this.grants)) {
      data['grants'] = [];
      for (let item of this.grants) data['grants'].push(item);
    }
    if (Array.isArray(this.otherIndexedKeywords)) {
      data['otherIndexedKeywords'] = [];
      for (let item of this.otherIndexedKeywords)
        data['otherIndexedKeywords'].push(item);
    }
    data['doi'] = this.doi;
    data['conflictsOfInterest'] = this.conflictsOfInterest;
    if (Array.isArray(this.pubtatorTerms)) {
      data['pubtatorTerms'] = [];
      for (let item of this.pubtatorTerms)
        data['pubtatorTerms'].push(item.toJSON());
    }
    if (Array.isArray(this.jointDeduplicatedMesh)) {
      data['jointDeduplicatedMesh'] = [];
      for (let item of this.jointDeduplicatedMesh)
        data['jointDeduplicatedMesh'].push(item.toJSON());
    }
    data['meshTermsByLevel'] = this.meshTermsByLevel
      ? this.meshTermsByLevel.toJSON()
      : <any>undefined;
    if (Array.isArray(this.classification)) {
      data['classification'] = [];
      for (let item of this.classification)
        data['classification'].push(item.toJSON());
    }
    data['isRct'] = this.isRct;
    data['isSr'] = this.isSr;
    data['isMa'] = this.isMa;
    if (Array.isArray(this.robotReviewer)) {
      data['robotReviewer'] = [];
      for (let item of this.robotReviewer)
        data['robotReviewer'].push(item.toJSON());
    }
    data['p5'] = this.p5 ? this.p5.toJSON() : <any>undefined;
    data['score'] = this.score ? this.score.toJSON() : <any>undefined;
    data['articleType'] = this.articleType;
    data['showDetail'] = this.showDetail;
    data['feedback'] = this.feedback;
    data['order'] = this.order;
    return data;
  }
}

export interface ISync4DataResult {
  id?: number;
  pmid?: string | undefined;
  database?: string | undefined;
  title?: string | undefined;
  abstract?: string | undefined;
  authors?: string[] | undefined;
  preIndexedMesh?: string[] | undefined;
  journal?: string | undefined;
  publicationDate?: string | undefined;
  pmc?: string | undefined;
  grants?: any[] | undefined;
  otherIndexedKeywords?: string[] | undefined;
  doi?: string | undefined;
  conflictsOfInterest?: any | undefined;
  pubtatorTerms?: PubtatorTerm[] | undefined;
  jointDeduplicatedMesh?: JointDeduplicatedMesh[] | undefined;
  meshTermsByLevel?: MeshTermsByLevel;
  classification?: Classification[] | undefined;
  isRct?: boolean;
  isSr?: boolean;
  isMa?: boolean;
  robotReviewer?: RobotReviewer[] | undefined;
  p5?: P5;
  score?: Score;
  articleType?: string | undefined;
  showDetail?: boolean;
  feedback?: number;
  order?: number;
}

export class SearchPage implements ISearchPage {
  articles?: Sync4DataResult[] | undefined;
  total?: number;
  pageIndex?: number;
  pageSize?: number;

  constructor(data?: ISearchPage) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['articles'])) {
        this.articles = [] as any;
        for (let item of _data['articles'])
          this.articles!.push(Sync4DataResult.fromJS(item));
      }
      this.total = _data['total'];
      this.pageIndex = _data['pageIndex'];
      this.pageSize = _data['pageSize'];
    }
  }

  static fromJS(data: any): SearchPage {
    data = typeof data === 'object' ? data : {};
    let result = new SearchPage();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.articles)) {
      data['articles'] = [];
      for (let item of this.articles) data['articles'].push(item.toJSON());
    }
    data['total'] = this.total;
    data['pageIndex'] = this.pageIndex;
    data['pageSize'] = this.pageSize;
    return data;
  }
}

export interface ISearchPage {
  articles?: Sync4DataResult[] | undefined;
  total?: number;
  pageIndex?: number;
  pageSize?: number;
}

export class DetailedArticle implements IDetailedArticle {
  id?: number;
  pmid?: string | undefined;
  database?: string | undefined;
  title?: string | undefined;
  abstract?: string | undefined;
  authors?: string[] | undefined;
  preIndexedMesh?: string[] | undefined;
  journal?: string | undefined;
  publicationDate?: string | undefined;
  pmc?: string | undefined;
  grants?: string[] | undefined;
  otherIndexedKeywords?: string[] | undefined;
  doi?: string | undefined;
  conflictsOfInterest?: string | undefined;
  pubtatorTerms?: PubtatorTerm[] | undefined;
  jointDeduplicatedMesh?: JointDeduplicatedMesh[] | undefined;
  meshTermsByLevel?: MeshTermsByLevel;
  score?: number;
  articleType?: string | undefined;

  constructor(data?: IDetailedArticle) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.pmid = _data['pmid'];
      this.database = _data['database'];
      this.title = _data['title'];
      this.abstract = _data['abstract'];
      if (Array.isArray(_data['authors'])) {
        this.authors = [] as any;
        for (let item of _data['authors']) this.authors!.push(item);
      }
      if (Array.isArray(_data['preIndexedMesh'])) {
        this.preIndexedMesh = [] as any;
        for (let item of _data['preIndexedMesh'])
          this.preIndexedMesh!.push(item);
      }
      this.journal = _data['journal'];
      this.publicationDate = _data['publicationDate'];
      this.pmc = _data['pmc'];
      if (Array.isArray(_data['grants'])) {
        this.grants = [] as any;
        for (let item of _data['grants']) this.grants!.push(item);
      }
      if (Array.isArray(_data['otherIndexedKeywords'])) {
        this.otherIndexedKeywords = [] as any;
        for (let item of _data['otherIndexedKeywords'])
          this.otherIndexedKeywords!.push(item);
      }
      this.doi = _data['doi'];
      this.conflictsOfInterest = _data['conflictsOfInterest'];
      if (Array.isArray(_data['pubtatorTerms'])) {
        this.pubtatorTerms = [] as any;
        for (let item of _data['pubtatorTerms'])
          this.pubtatorTerms!.push(PubtatorTerm.fromJS(item));
      }
      if (Array.isArray(_data['jointDeduplicatedMesh'])) {
        this.jointDeduplicatedMesh = [] as any;
        for (let item of _data['jointDeduplicatedMesh'])
          this.jointDeduplicatedMesh!.push(JointDeduplicatedMesh.fromJS(item));
      }
      this.meshTermsByLevel = _data['meshTermsByLevel']
        ? MeshTermsByLevel.fromJS(_data['meshTermsByLevel'])
        : <any>undefined;
      this.score = _data['score'];
      this.articleType = _data['articleType'];
    }
  }

  static fromJS(data: any): DetailedArticle {
    data = typeof data === 'object' ? data : {};
    let result = new DetailedArticle();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['pmid'] = this.pmid;
    data['database'] = this.database;
    data['title'] = this.title;
    data['abstract'] = this.abstract;
    if (Array.isArray(this.authors)) {
      data['authors'] = [];
      for (let item of this.authors) data['authors'].push(item);
    }
    if (Array.isArray(this.preIndexedMesh)) {
      data['preIndexedMesh'] = [];
      for (let item of this.preIndexedMesh) data['preIndexedMesh'].push(item);
    }
    data['journal'] = this.journal;
    data['publicationDate'] = this.publicationDate;
    data['pmc'] = this.pmc;
    if (Array.isArray(this.grants)) {
      data['grants'] = [];
      for (let item of this.grants) data['grants'].push(item);
    }
    if (Array.isArray(this.otherIndexedKeywords)) {
      data['otherIndexedKeywords'] = [];
      for (let item of this.otherIndexedKeywords)
        data['otherIndexedKeywords'].push(item);
    }
    data['doi'] = this.doi;
    data['conflictsOfInterest'] = this.conflictsOfInterest;
    if (Array.isArray(this.pubtatorTerms)) {
      data['pubtatorTerms'] = [];
      for (let item of this.pubtatorTerms)
        data['pubtatorTerms'].push(item.toJSON());
    }
    if (Array.isArray(this.jointDeduplicatedMesh)) {
      data['jointDeduplicatedMesh'] = [];
      for (let item of this.jointDeduplicatedMesh)
        data['jointDeduplicatedMesh'].push(item.toJSON());
    }
    data['meshTermsByLevel'] = this.meshTermsByLevel
      ? this.meshTermsByLevel.toJSON()
      : <any>undefined;
    data['score'] = this.score;
    data['articleType'] = this.articleType;
    return data;
  }
}

export interface IDetailedArticle {
  id?: number;
  pmid?: string | undefined;
  database?: string | undefined;
  title?: string | undefined;
  abstract?: string | undefined;
  authors?: string[] | undefined;
  preIndexedMesh?: string[] | undefined;
  journal?: string | undefined;
  publicationDate?: string | undefined;
  pmc?: string | undefined;
  grants?: string[] | undefined;
  otherIndexedKeywords?: string[] | undefined;
  doi?: string | undefined;
  conflictsOfInterest?: string | undefined;
  pubtatorTerms?: PubtatorTerm[] | undefined;
  jointDeduplicatedMesh?: JointDeduplicatedMesh[] | undefined;
  meshTermsByLevel?: MeshTermsByLevel;
  score?: number;
  articleType?: string | undefined;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new ApiException(message, status, response, headers, null)
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
